import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Sprite from './Sprite'
import { CreateLink } from '../utils'
import { iOS, android, appButtonUrls } from '../device'
import { getSessionItem, setSessionItem } from '../storeManager'
import { FormattedMessage } from 'react-intl'
import messages from './Header/messages'
import { withLocale } from '../locale'
import { trackStartRegistration } from '../analytics'
import { localeShape } from '../locale'
import { connect } from 'react-redux'
import { selectIsAuthenticated } from 'js/store/userSlice'
import { isSSR } from 'js/isSSR'

class InstallBanner extends React.Component {
  wrapper = React.createRef()

  static propTypes = {
    install: PropTypes.bool,
    locale: localeShape,
    isAuthenticated: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      link: null,
      storeText: '',
      shouldRender: false,
    }

    this.close = this.close.bind(this)
    this.trackClick = this.trackClick.bind(this)
  }

  componentDidMount() {
    // Allow other components to set bannerShown
    setTimeout(() => {
      // Only show banner once per session
      if (!getSessionItem('bannerShown')) {
        this.setState({
          shouldRender: true,
          link: iOS ? appButtonUrls.apple : appButtonUrls.google,
          storeText: iOS ? 'App Store' : 'Google Play',
        })
      }

      setSessionItem('bannerShown', true)

      const header = document.querySelector('.c-header:not(.c-header--stuck)')

      if (header && this.wrapper.current) {
        header.style.marginTop =
          this.wrapper.current.getBoundingClientRect().height + 'px'
      }
    }, 500)
  }

  close() {
    this.setState(
      {
        shouldRender: false,
      },
      () => {
        const header = document.querySelector('.c-header')

        if (header) {
          header.style.marginTop = '0'
        }
      }
    )
  }

  trackClick(e) {
    if (typeof ga !== 'undefined' && !this.props.isAuthenticated) {
      e.preventDefault()
      const link = e.currentTarget

      ga('send', {
        hitType: 'event',
        eventCategory: 'App store buttons',
        eventAction: 'Banner click',
        eventLabel: this.state.storeText,
        eventValue: 3,
        hitCallback: function() {
          document.location.href = link.getAttribute('href')
        },
      })

      // Fallback if GA doesn't fire hitCallback
      setTimeout(function() {
        document.location.href = link.getAttribute('href')
      }, 500)
    }
  }

  render = () => {
    if (isSSR) return null
    if (navigator.userAgent.match('DisableForTesting')) return null
    if (!(iOS || android)) return null

    return (
      <div className="c-install-banner" ref={this.wrapper}>
        {this.state.shouldRender && typeof this.state.link === 'string' && (
          <div className="c-install-banner__inner">
            <button onClick={this.close}>
              <Sprite id="close" />
              <span className="visually-hidden">Close banner</span>
            </button>
            <img
              className="rounded-8"
              src={require('media/app-icon.jpg')}
              alt="Lifesum app icon"
            />
            <div>
              <span className="c-install-banner__heading">Lifesum</span>
              <div className="c-review  c-install-banner__stars">
                <div className="c-review__rating  c-review__rating--4-5" />
              </div>
              <span className="c-install-banner__store">
                {this.state.storeText}
              </span>
            </div>
            {this.props.install && (
              <a
                className="ml-auto text-center text-green font-demibold border-2 border-color-green rounded-4 px-16 py-2"
                href={this.state.link}
                onClick={this.trackClick}
              >
                <FormattedMessage {...messages.install_now} />
              </a>
            )}
            {!this.props.install && (
              <Link
                to={CreateLink('signup/', this.props.locale.language)}
                className="ml-auto text-center text-green font-demibold border-2 border-color-green rounded-4 px-16 py-2"
                onClick={() => {
                  trackStartRegistration({
                    entryPoint: 'Mobile Banner',
                    flowName: 'Regular',
                  })
                }}
              >
                <FormattedMessage {...messages.signUp} />
              </Link>
            )}
          </div>
        )}
      </div>
    )
  }
}

InstallBanner.defaultProps = {
  install: false,
}

export default connect(state => ({
  isAuthenticated: selectIsAuthenticated(state),
}))(withLocale(InstallBanner))
